import React from 'react';
import { Cell } from '../../../cell/cell';
import { Container } from '../../../container/container';
import { FormControl } from '../../../form-control/form-control';
import { FormDialog } from '../../../form-dialog/form-dialog';
import { Row } from '../../../row/row';
import { TeamLookup } from '../../../lookups/team-lookup/team-lookup';
import { UserLookup } from '../../../lookups/user-lookup/user-lookup';
import { Box } from '../../../box/box';

export interface IAssignCaseworkerAppointmentDialogComponentProps {
  teamId?: string;
  userId?: string;
  isLoading?: boolean;
  onTeamChange: (team: string | undefined) => void;
  onUserChange: (userId: string | undefined) => void;
  open: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function AssignCaseworkerAppointmentDialogComponent({
  teamId,
  userId,
  onTeamChange,
  onUserChange,
  open,
  onConfirm,
  onClose,
  isLoading,
}: IAssignCaseworkerAppointmentDialogComponentProps) {
  return (
    <FormDialog
      open={open}
      title="Tildel ansvarlig sagsbehandler til de valgte virksomhedsaftaler"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <FormControl fullWidth>
        <Container>
          <Box width="1000px">
            {/* <Row>
              <Cell size="full">Bemærk: Poster som repræsenterer tidligere migrerede planlagte samtaler vil ikke være omfattet af handlingen</Cell>
            </Row> */}
            <Row>
              <Cell size="full">
                <UserLookup value={userId} onChange={onUserChange} />
              </Cell>
              <Cell size="full">
                <TeamLookup required value={teamId} onChange={onTeamChange} disableClearable />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
